import { motion } from 'motion/react'
import { ArrowRight, Server, Wallet } from 'lucide-react'

interface CTABannerProps {
  title?: string
  description?: string
  primaryLabel?: string
  primaryHref?: string
  showPriceMeta?: boolean
}

/**
 * Banner CTA reutilizable para secciones finales de páginas
 * de marketing. Reusa los tokens del tema (acento morado).
 */
export function CTABanner({
  title = '¿Listo para empezar?',
  description = 'Crea tu primer servidor en menos de 2 minutos y paga solo por el tiempo que lo uses.',
  primaryLabel = 'Crear mi servidor',
  primaryHref = '/login',
  showPriceMeta = true,
}: CTABannerProps) {
  return (
    <section className="marketing-cta">
      <div className="marketing-cta-bg" aria-hidden="true" />
      <motion.div
        className="marketing-cta-content"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.7 }}
      >
        <motion.div
          className="marketing-cta-badge"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Server size={14} /> Hosting en minutos
        </motion.div>

        <h2 className="marketing-cta-title">{title}</h2>
        <p className="marketing-cta-desc">{description}</p>

        <div className="marketing-cta-actions">
          <motion.a
            href={primaryHref}
            className="marketing-cta-primary"
            whileHover={{ y: -3, scale: 1.02 }}
            whileTap={{ scale: 0.96 }}
          >
            {primaryLabel}
            <ArrowRight size={16} />
          </motion.a>

          {showPriceMeta && (
            <div className="marketing-cta-meta">
              <Wallet size={14} /> Desde $1
            </div>
          )}
        </div>
      </motion.div>
    </section>
  )
}
